import React, { Component } from 'react'
import { connect } from 'react-redux'

import initEditorValueWithDelta from '@slite/editor/lib/adapter/editor/init'
import Editor from 'components/Editors/Editor'
import createHistoryPlugins from 'components/Editors/plugins/createHistoryPlugins'
import { selectors as ConfigSelectors } from 'data/config'

const prepareSnapshot = snapshot => {
  // Add a line at snapshot end if needd
  const newLine = snapshot.ops.reduce((memo, op) => {
    return memo && !(typeof op.insert === 'string' && op.insert.includes('\n'))
  }, true)
  return newLine ? snapshot.insert('\n') : snapshot
}

const generateEditorValue = (snapshot, decorator) => {
  const preparedSnapshot = prepareSnapshot(snapshot)
  return initEditorValueWithDelta(preparedSnapshot)
}

class NotesHistoryEditor extends Component {
  constructor(props) {
    super(props)
    this.plugins = createHistoryPlugins({
      iframelyApiKey: props.iframelyApiKey,
    })
    this.state = {
      editorValue: generateEditorValue(props.snapshot),
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.activeVersionNum !== this.props.activeVersionNum ||
      nextProps.showHistoryDecorators !== this.props.showHistoryDecorators
    ) {
      this.setState({
        editorValue: generateEditorValue(nextProps.snapshot),
      })
    }
  }

  onEditorChange = ({ value }) => {
    this.setState({ editorValue: value })
  }

  render() {
    const { activeVersionNum, showHistoryDecorators } = this.props
    const { editorValue } = this.state

    return (
      <Editor
        value={editorValue}
        readOnly={true}
        onChange={this.onEditorChange}
        key={`${activeVersionNum}-${showHistoryDecorators}`} // useful to force editor rerender
        placeholder="This doc is empty"
        historyEditor
        noteEditor
        plugins={this.plugins}
      />
    )
  }
}

export default connect(state => ({
  iframelyApiKey: ConfigSelectors.getIframelyApiKey(state),
}))(NotesHistoryEditor)
